import API_BASE, { getAuthToken } from "../services/apiClient";

export async function downloadAdminPdf(type, id) {
  const response = await fetch(`${API_BASE}/admin/documents/${encodeURIComponent(type)}/${encodeURIComponent(id)}/pdf`, {
    headers: { Authorization: `Bearer ${getAuthToken()}` },
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `PDF download failed (HTTP ${response.status}). The API server may need to be updated.`);
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${type}-${id}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}